import React from "react";
import { DocumentManager } from "@/components/admin/DocumentManager";

export default function AdminManuals() {
  return (
    <DocumentManager
      fixedType="manual"
      title="User Manuals"
      subtitle="Manage owner and appliance manuals. Assign to models, equipment and set customer visibility."
    />
  );
}
